import React, { useState } from 'react'
import { Form } from 'react-bootstrap'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/pro-solid-svg-icons';
import ReportAdvancedOptionsModal from './ReportAdvancedOptionsModal';
import CHARTCOLORS from '../../helpers/chartColors';

export default function ReportAdvancedOptions(props) {
  const { optionsList, payload, updatePayload } = props;

  const [showModal, setShowModal] = useState(false)

  return <>
    <Form.Group>
      <Form.Label>Advanced Options <FontAwesomeIcon
        style={{
          fontSize: '20px',
          marginLeft: '0.5em',
          color: CHARTCOLORS[1],
          cursor: 'pointer',
        }}
        icon={faEdit}
        onClick={() => setShowModal(true)}
      /> </Form.Label>
    </Form.Group>
    <ReportAdvancedOptionsModal
      show={showModal}
      onHide={() => setShowModal(false)}
      payload={payload}
      updatePayload={updatePayload}
      optionsList={optionsList}

    />
  </>
}